/*
 * Planigo
 * Auteur  : Stéphane Raverdy
 * Société : SCIAD 2026
 */
import { useEffect, useState } from 'react';

// REGLE DE GESTION V4 : telephone et tablette utilisent des ecrans dedies.
// Le pointeur tactile permet aussi de couvrir les tablettes en mode paysage jusqu'a 1366px
// sans basculer les postes desktop classiques de meme largeur.
const COMPACT_QUERY = '(max-width: 1024px), (pointer: coarse) and (max-width: 1366px)';
export default function useCompactMode() {
  const getValue = () => typeof window !== 'undefined' && window.matchMedia(COMPACT_QUERY).matches;
  const [compact, setCompact] = useState(getValue);
  useEffect(() => {
    const media = window.matchMedia(COMPACT_QUERY);
    const update = () => setCompact(media.matches);
    media.addEventListener?.('change', update);
    return () => media.removeEventListener?.('change', update);
  }, []);
  return compact;
}
